import { Grid2, Stack, Typography, useTheme } from "@mui/material";
import { ActionMultivalue } from "../../../../context/utils/formatMultivalue/formatMultivalue";
import { Fragment } from "react/jsx-runtime";
import { ActionFieldInputComponent } from "../Inputs/ActionFieldInputComponent";
import { ActionField } from "src/api/client-api/ActionPlan/ActionPlanAction";
import { PreviousValue } from "../Common/PreviousValue";

type Props = {
    actionMultivalue: ActionMultivalue | null;
    actionField: ActionField;
};
export const OneSubproperty = (props: Props) => {
    const theme = useTheme();
    const { actionMultivalue, actionField } = props;

    if (actionMultivalue === null) {
        return null;
    }

    if (actionMultivalue.rows.length === 0) {
        return null;
    }
    const firstRow = actionMultivalue.rows[0];

    return (
        <Stack>
            <Grid2
                border={`1px solid ${theme.custom.grey[600]}`}
                borderRadius={theme.spacing(1.5)}
                columns={12}
                container
            >
                {/* Firstline */}
                <Grid2
                    sx={{
                        borderTopLeftRadius: theme.spacing(1.5),
                        borderTopRightRadius: theme.spacing(1.5),
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    }}
                    bgcolor={theme.custom.grey[200]}
                    borderBottom={`1px solid ${theme.custom.grey[600]}`}
                    size={12}
                    columns={12}
                    container
                >
                    <Grid2 size={4} padding={theme.spacing(2)} alignContent={"center"}>
                        <Typography variant="body-bold">{firstRow.rowHierarchy.title}</Typography>
                    </Grid2>
                    <Grid2 size={8} padding={theme.spacing(2)} alignContent={"center"}>
                        <Typography variant="body-bold">{actionField.question}</Typography>
                    </Grid2>
                </Grid2>
                {actionMultivalue.rows.map((row) => {
                    if (row.actionFieldByMulti.length === 0) {
                        return null;
                    }
                    const subproperty = row.actionFieldByMulti[0];
                    const fieldValue = subproperty.fieldValue;
                    const startingValue = subproperty.startingValue;

                    return (
                        <Fragment key={row.position}>
                            <Grid2 size={4} padding={theme.spacing(2)} alignContent={"center"}>
                                <Typography variant="body-bold">{row.rowHierarchy.label}</Typography>
                            </Grid2>
                            <Grid2 size={8} padding={theme.spacing(2)}>
                                <Stack gap={theme.spacing(1)}>
                                    <ActionFieldInputComponent
                                        fieldValue={fieldValue}
                                        unit={subproperty.unit}
                                        dataListOptions={subproperty.dataListOptions}
                                        fieldType={subproperty.fieldType}
                                        disabled={subproperty.disabled}
                                        position={subproperty.position}
                                        actionFieldId={subproperty.actionFieldId}
                                    />
                                    {startingValue.value !== undefined && (
                                        <PreviousValue
                                            year={startingValue.label}
                                            value={startingValue.value}
                                            unit={startingValue.unit}
                                        />
                                    )}
                                </Stack>
                            </Grid2>
                        </Fragment>
                    );
                })}
            </Grid2>
        </Stack>
    );
};
